export const normalizeCurrency = (currency, fallback = "USD") => {
  const value = String(currency || "").trim().toUpperCase();
  return /^[A-Z]{3}$/.test(value) ? value : fallback;
};

export const formatMoney = (
  amount,
  currency,
  {
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = {},
) => {
  const code = normalizeCurrency(currency);
  const value = Number(amount) || 0;

  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(value);
  } catch {
    return `${code} ${value.toLocaleString(undefined, {
      minimumFractionDigits,
      maximumFractionDigits,
    })}`;
  }
};
